const unsafePathCharacter = /[\\\u0000-\u001f\u007f]/;

export function safeRedirectPath(value: unknown, fallback: string) {
  if (typeof value !== "string") return fallback;
  if (!value.startsWith("/") || value.startsWith("//")) return fallback;
  if (unsafePathCharacter.test(value)) return fallback;
  return value;
}
